import styled from 'styled-components'
import { mapBreakpoints } from 'etymos'
import Clickable from 'components/Clickable'

import getTypeStyle from 'utils/getTypeStyle'

const mapping = mapBreakpoints(getTypeStyle)

const Text = styled.div`
	${mapping}
	${p => p.color && `color: var(--color-${p.color}) !important;`}
	${p => p.rawColor && `color: ${p.rawColor} !important;`}
	${p => p.background && `background: var(--color-${p.background}) !important;`}
	${p => p.weight && `font-weight: ${p.weight} !important;`}
	${p => p.lineHeight && `line-height: ${p.lineHeight} !important;`}
	${p => p.transform && `text-transform: ${p.transform} !important;`}
	${p => p.letterSpacing && `letter-spacing: ${p.letterSpacing} !important;`}
	${p => p.family && `font-family: ${p.theme.typography.fonts?.[p.family]} !important;`}
	${p => p.rawFontSize && `font-size: ${p.rawFontSize} !important;`}
`

/* eslint-disable no-unused-vars */
// Hero Title Typography Component - defaults as h1
const heroTitleAttrs = ({ theme, ...p }) => ({
	as: 'h1',
	xs: 'heroTitleXs',
	s900: 'heroTitle',
	...p,
})
export const HeroTitle = styled(Text).attrs(heroTitleAttrs)``

// Big Title Typography Component - defaults as h2
const bigTitleAttrs = ({ theme, ...p }) => ({
	as: 'h2',
	xs: 'bigTitleXs',
	s900: 'bigTitle',
	...p,
})
export const BigTitle = styled(Text).attrs(bigTitleAttrs)``

// Section Title Typography Component - defaults as h2
const sectionTitleAttrs = ({ theme, ...p }) => ({
	as: 'h2',
	xs: 'sectionTitleXs',
	sm: 'sectionTitle',
	...p,
})

// Small Title Typography Component - defaults as h3
export const SmallTitle = styled(Text).attrs(({ theme, ...p }) => ({
	as: 'h3',
	xs: 'smallTitle',
	...p,
}))``

// Subtitle Typography Component - defaults as h4
const subtitleAttrs = ({ theme, ...p }) => ({
	as: 'h4',
	xs: 'subtitleXs',
	sm: 'subtitle',
	...p,
})
export const Subtitle = styled(Text).attrs(subtitleAttrs)``

const smallSubtitleAttrs = ({ theme, ...p }) => ({
	as: 'h4',
	xs: 'smallSubtitleXs',
	sm: 'smallSubtitle',
	...p,
})
export const SmallSubtitle = styled(Text).attrs(smallSubtitleAttrs)``

// Body Copy Typography Component - defaults as p
const bodyCopyAttrs = ({ theme, ...p }) => ({
	as: 'p',
	xs: 'bodyCopyXs',
	sm: 'bodyCopy',
	...p,
})
export const BodyCopy = styled(Text).attrs(bodyCopyAttrs)``

// Link Typography Component
const linkAttrs = ({ theme, ...p }) => ({ as: Clickable, xs: 'link', ...p })
export const Link = styled(Text).attrs(linkAttrs)``

// Tag Typography Component
const tagAttrs = ({ theme, ...p }) => ({
	as: 'span',
	xs: 'tagXs',
	sm: 'tag',
	...p,
})
export const TagCopy = styled(Text).attrs(tagAttrs)``

// Small Body Copy Typography Component - defaults as p
const smallBodyAttrs = ({ theme, ...p }) => ({
	as: 'p',
	xs: 'smallBodyCopyXs',
	sm: 'smallBodyCopy',
	...p,
})
export const SmallBodyCopy = styled(Text).attrs(smallBodyAttrs)``

const docsBodyAttrs = ({ theme, ...p }) => ({
	as: 'p',
	xs: 'docsBodyCopyXs',
	sm: 'docsBodyCopy',
	...p,
})
export const DocsBodyCopy = styled(Text).attrs(docsBodyAttrs)``

// Caption Typography Component - defaults as p
const captionAttrs = ({ theme, ...p }) => ({
	as: 'p',
	xs: 'captionCopy',
	...p,
})
export const Caption = styled(Text).attrs(captionAttrs)``

// Label Copy Typography Component - defaults as span
const labelAttrs = ({ theme, ...p }) => ({ as: 'span', xs: 'labelCopy', ...p })
export const Label = styled(Text).attrs(labelAttrs)``

export default Text
